module.exports = __webpack_public_path__ + "static/img_9593-c56f62ab2b0fc81d6e513eace612b2b5.webp";